module.exports = __webpack_public_path__ + "static/health-smart-behavior-body-1-291a9cdd275f490d0a788446c894dfca.jpg";